const NETWORK_COLORS: Record<string, string> = {
  x: "bg-black text-white",
  twitter: "bg-black text-white",
  ig: "bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 text-white",
  instagram: "bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 text-white",
  fb: "bg-blue-600 text-white",
  facebook: "bg-blue-600 text-white",
  li: "bg-blue-700 text-white",
  linkedin: "bg-blue-700 text-white",
  yt: "bg-red-600 text-white",
  youtube: "bg-red-600 text-white",
  tt: "bg-black text-white",
  tiktok: "bg-black text-white",
  reddit: "bg-orange-500 text-white",
  news: "bg-ink-700 text-white",
  reviews: "bg-yellow-500 text-white",
};

const NETWORK_LETTER: Record<string, string> = {
  x: "𝕏", twitter: "𝕏",
  ig: "Ig", instagram: "Ig",
  fb: "f", facebook: "f",
  li: "in", linkedin: "in",
  yt: "▶", youtube: "▶",
  tt: "♪", tiktok: "♪",
  reddit: "r", news: "N", reviews: "★",
};

export function SocialDot({ network, size = 24 }: { network: string; size?: number }) {
  const klass = NETWORK_COLORS[network] ?? "bg-ink-500 text-white";
  const letter = NETWORK_LETTER[network] ?? network.slice(0, 2).toUpperCase();
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold shrink-0 ${klass}`}
      style={{ width: size, height: size, fontSize: Math.max(8, size * 0.45) }}
      aria-label={network}
    >
      {letter}
    </span>
  );
}
